import { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useHistory } from "react-router-dom";

import "./WelcomeToZeely.scss";
import { Helmet } from "react-helmet";
import axios from "axios";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import useMixpanel from "../../hooks/useMixpanel";
import CryptoJS from 'crypto-js';

const WelcomeToZeely = () => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const setVHVariable = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVHVariable();
    window.addEventListener("resize", setVHVariable);
    return () => window.removeEventListener("resize", setVHVariable);
  }, []);

  const [name, setName] = useState("");

  const secretKey = 'j5wbjG3jNJMCSI9';

  const decryptText = (ciphertext) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    const original = bytes.toString(CryptoJS.enc.Utf8);
    return original;
  };

  const decryptName = decryptText(queryParams.get('un') || "") || "";

  useEffect(() => {
    if (queryParams) {
      setName(decryptName);
    }
  }, [queryParams]);

  const { trackEvent } = useMixpanel()

  useEffect(() => {
    setTimeout(() => {
      trackEvent("onboarding_web_loader", { name: name })
    }, 1000);
  }, [])

  const logo1Ref = useRef(null);
  const logo2Ref = useRef(null);
  const circleRef = useRef(null);

  const text1Ref = useRef(null);
  const text2Ref = useRef(null);
  const text3Ref = useRef(null);
  const text4Ref = useRef(null);
  const text5Ref = useRef(null);

  const [headColor, setHeadColor] = useState("#fff");

  useEffect(() => {
    setTimeout(() => {
      setHeadColor("#5BF0A5");
    }, 4000);
    const tl = gsap.timeline({
      onComplete: () => {
        console.log(history.location.pathname);
        if (history.location.pathname == "/welcome") {
          history.push({
            pathname: queryParams.get('new-account') ? "/password" : '/confirm-email',
            search: `?${queryParams.toString()}`,
          });
        }
      },
    });

    tl.fromTo(
      logo1Ref.current,
      {
        opacity: 0,
      },
      {
        duration: 1,
        opacity: 1,
        ease: "power4.out",
        deley: 1,
      }
    );
    tl.fromTo(
      logo2Ref.current,
      {
        opacity: 0,
        y: "50%",
      },
      {
        y: "0",
        duration: 1,
        opacity: 1,
        ease: "power4.out",
      }
    );

    tl.fromTo(
      circleRef.current,
      {
        opacity: 0,
        scale: 0,
      },
      {
        duration: 3,
        ease: "power4.out",
        opacity: 1,
        scale: 2.5,
      }
    );

    tl.to([logo1Ref.current, logo2Ref.current], {
      duration: 1,
      opacity: 0,
      ease: "power4.out",
    });

    tl.fromTo(
      text1Ref.current,
      {
        opacity: 0,
      },
      {
        duration: 1,
        ease: "power4.out",
        opacity: 1,
      }
    );
    tl.to(text1Ref.current, {
      duration: 1,
      opacity: 0,
      ease: "power4.out",
      delay: 1,
    });

    tl.fromTo(
      text2Ref.current,
      {
        opacity: 0,
      },
      {
        duration: 1,
        ease: "power4.out",
        opacity: 1,
      }
    );
    tl.to(text2Ref.current, {
      duration: 1,
      opacity: 0,
      ease: "power4.out",
      delay: 1,
    });

    tl.fromTo(
      text3Ref.current,
      {
        opacity: 0,
      },
      {
        duration: 1,
        ease: "power4.out",
        opacity: 1,
      }
    );
    tl.to(text3Ref.current, {
      duration: 1,
      opacity: 0,
      ease: "power4.out",
      delay: 1,
    });

    tl.fromTo(
      text4Ref.current,
      {
        opacity: 0,
      },
      {
        duration: 1,
        ease: "power4.out",
        opacity: 1,
      }
    );
    tl.to(text4Ref.current, {
      duration: 1,
      opacity: 0,
      ease: "power4.out",
      delay: 1,
    });

    tl.fromTo(
      text5Ref.current,
      {
        opacity: 0,
      },
      {
        duration: 1,
        ease: "power4.out",
        opacity: 1,
      }
    );
    tl.to(text5Ref.current, {
      duration: 1,
      opacity: 0,
      ease: "power4.out",
      delay: 1,
    });
  }, []);

  const [total, setTotal] = useState("");
  const [plan, setPlan] = useState("");
  useEffect(() => {
    if (localStorage.getItem("price")) {
      if (localStorage.getItem("price") == "0") {
        setTotal("19.95");
        setPlan("2 weeks");
      }
      if (localStorage.getItem("price") == "1") {
        setTotal("29.95");
        setPlan("1 month");
      }
      if (localStorage.getItem("price") == "2") {
        setTotal("49.95");
        setPlan("2 months");
      }
    }
  }, []);

  // useEffect(() => {
  //   if (total != "") {
  //     sendData();
  //   }
  // }, [total]);


  useEffect(() => {
    document.documentElement.style.overflow = 'hidden';
  }, [])

  return (
    <div className="welcometo">
      <Helmet>
        <meta name="theme-color" content={headColor}></meta>
      </Helmet>
      <div className="welcometo-logo">
        <span ref={logo1Ref}>Welcome to</span>
        <strong ref={logo2Ref}>
          <svg
            width="220"
            height="47"
            viewBox="0 0 220 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="95.334"
              width="123.733"
              height="46.9333"
              rx="23.4667"
              fill="#5BF0A5"
            />
            <path
              d="M117.822 26.3998H112.934L119.778 12.7109V20.5332H124.667L117.822 34.222V26.3998Z"
              fill="black"
            />
            <path
              d="M143.065 26.9956C144.174 26.9956 145.139 26.7081 146.001 26.1127C146.843 25.5172 147.418 24.7164 147.726 23.7103H143.065V21.7801H150.334C150.334 23.854 149.635 25.5993 148.239 27.0161C146.843 28.4329 145.118 29.1311 143.044 29.1311C140.97 29.1311 139.246 28.4535 137.849 27.0983C136.453 25.7431 135.775 24.0593 135.775 22.0265C135.775 20.0143 136.474 18.31 137.87 16.9137C139.266 15.538 140.991 14.8399 143.044 14.8399C144.564 14.8399 145.919 15.2505 147.151 16.0308C148.383 16.8316 149.266 17.8993 149.8 19.234H147.192C146.74 18.5359 146.165 17.9815 145.447 17.5708C144.707 17.1601 143.927 16.9548 143.065 16.9548C141.689 16.9548 140.539 17.4476 139.595 18.4127C138.65 19.3983 138.198 20.5892 138.198 21.9855C138.198 23.4023 138.65 24.5932 139.595 25.5583C140.539 26.5233 141.689 26.9956 143.065 26.9956ZM154.584 22.8273V28.9668H152.346V18.7823H154.523V19.8089C154.769 19.4188 155.098 19.1108 155.488 18.9055C155.857 18.7001 156.289 18.5769 156.781 18.5769C157.089 18.5769 157.377 18.618 157.644 18.7001C157.911 18.7823 158.137 18.9055 158.301 19.0492L157.172 21.0204C157.007 20.9383 156.864 20.8561 156.699 20.8151C156.535 20.774 156.391 20.7535 156.248 20.7535C155.714 20.7535 155.303 20.9588 155.016 21.3284C154.728 21.698 154.584 22.2113 154.584 22.8273ZM163.687 18.5769C165.186 18.5769 166.459 19.0903 167.486 20.0964C168.512 21.1231 169.026 22.3756 169.026 23.854C169.026 25.3529 168.512 26.6055 167.486 27.6116C166.459 28.6383 165.186 29.1311 163.687 29.1311C162.168 29.1311 160.915 28.6383 159.888 27.6116C158.862 26.6055 158.348 25.3529 158.348 23.854C158.348 22.3756 158.862 21.1231 159.888 20.0964C160.915 19.0903 162.168 18.5769 163.687 18.5769ZM160.607 23.854C160.607 24.7575 160.894 25.5172 161.49 26.1332C162.085 26.7492 162.825 27.0572 163.687 27.0572C164.529 27.0572 165.248 26.7492 165.864 26.1332C166.459 25.5172 166.767 24.7575 166.767 23.854C166.767 22.9711 166.459 22.2113 165.864 21.5953C165.248 20.9793 164.529 20.6508 163.687 20.6508C162.825 20.6508 162.085 20.9588 161.49 21.5748C160.894 22.1908 160.607 22.9505 160.607 23.854ZM185.175 18.7823L181.787 28.9668H179.652L177.331 22.0881H177.27L174.847 28.9668H172.732L169.508 18.7823H171.849L174.046 25.8868H174.108L176.531 18.7823H178.235L180.514 25.8457H180.617L182.896 18.7823H185.175ZM191.052 26.9751V28.9668H189.902C188.875 28.9668 188.136 28.7409 187.705 28.2892C187.253 27.8375 187.048 27.0777 187.048 26.01V20.7329H185.631V18.7823H187.048V16.2361H189.286V18.7823H191.031V20.7329H189.286V25.6404C189.286 26.1743 189.368 26.5233 189.553 26.7081C189.717 26.8929 190.046 26.9751 190.518 26.9751H191.052ZM201.234 22.1703V28.9668H198.996V22.5193C198.996 21.9444 198.811 21.4721 198.442 21.1231C198.072 20.774 197.6 20.5892 197.004 20.5892C196.388 20.5892 195.875 20.774 195.464 21.1436C195.054 21.5132 194.869 21.9649 194.869 22.4988V28.9668H192.631V15.0041H194.869V19.9527C195.156 19.542 195.547 19.1929 196.039 18.9465C196.532 18.7001 197.087 18.5769 197.703 18.5769C198.791 18.5769 199.653 18.9055 200.29 19.542C200.906 20.1991 201.234 21.0615 201.234 22.1703Z"
              fill="black"
            />
            <g clip-path="url(#clip0_10810_25932)">
              <path
                d="M37.9114 23.5377C37.8752 20.8247 36.97 18.582 35.1597 16.8095C33.3494 15.0731 31.0683 14.205 28.2804 14.205C25.4925 14.205 23.1753 15.0731 21.365 16.8095C19.5184 18.582 18.6133 20.7885 18.6133 23.5015C18.6133 26.2145 19.5184 28.4211 21.365 30.1574C23.1753 31.8938 25.4925 32.7619 28.2804 32.7619C30.489 32.7619 32.4804 32.147 34.2183 30.8809C35.9562 29.6148 37.0786 28.0232 37.5855 26.0698H32.8425C32.1545 27.6976 30.3804 28.9275 28.3166 28.9275C25.8546 28.9275 23.8994 27.2997 23.3201 24.9485H37.7666C37.8752 24.5506 37.9114 24.0803 37.9114 23.5377ZM28.3166 18.0394C30.5977 18.0394 32.589 19.3778 33.3132 21.3673H23.5012C24.2615 19.3416 26.108 18.0394 28.3166 18.0394Z"
                fill="black"
              />
              <path
                d="M58.4289 23.5377C58.3927 20.8247 57.4875 18.582 55.6772 16.8095C53.8669 15.0731 51.5859 14.205 48.798 14.205C46.0101 14.205 43.6928 15.0731 41.8825 16.8095C40.036 18.582 39.1308 20.7885 39.1308 23.5015C39.1308 26.2145 40.036 28.4211 41.8825 30.1574C43.6928 31.8938 46.0101 32.7619 48.798 32.7619C51.0066 32.7619 52.9979 32.147 54.7358 30.8809C56.4738 29.6148 57.5962 28.0232 58.1031 26.0698H53.36C52.6721 27.6976 50.8979 28.9275 48.8342 28.9275C46.3721 28.9275 44.417 27.2997 43.8377 24.9485H58.2841C58.3927 24.5506 58.4289 24.0803 58.4289 23.5377ZM48.8342 18.0394C51.1152 18.0394 53.1065 19.3778 53.8307 21.3673H44.0187C44.779 19.3416 46.6256 18.0394 48.8342 18.0394Z"
                fill="black"
              />
              <path
                d="M60.6259 32.4364H65.3328V7.33203H60.6259V32.4364Z"
                fill="black"
              />
              <path
                d="M76.7033 25.8166L71.7068 14.5667H66.6741L74.4947 30.5192L69.8965 39.5987H74.8206L86.5153 14.5667H81.5912L76.7033 25.8166Z"
                fill="black"
              />
              <path
                d="M13.0153 14.5645H18.3949L6.06712 32.4347H0.6875L13.0153 14.5645Z"
                fill="black"
              />
              <path
                d="M1.17383 14.5645H14.3779V18.594H1.17383V14.5645Z"
                fill="black"
              />
              <path
                d="M4.81055 28.4043H17.5068V32.4339H4.81055V28.4043Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_10810_25932">
                <rect
                  width="86.5333"
                  height="32.2667"
                  fill="white"
                  transform="translate(0 7.33398)"
                />
              </clipPath>
            </defs>
          </svg>
        </strong>
      </div>
      <h3 className="welcometo-text--1" ref={text1Ref}>
        You're in! Thanks for trusting us, {name}.

      </h3>
      <h3 className="welcometo-text--2" ref={text2Ref}>
        We’re so excited to have you with us!
      </h3>
      <h3 className="welcometo-text--3" ref={text3Ref}>
        Now, AI will take a close look at your business...
      </h3>
      <h3 className="welcometo-text--4" ref={text4Ref}>
        To see what works and what can work even better
      </h3>
      <h3 className="welcometo-text--5" ref={text5Ref}>
        But first let’s set up your password
      </h3>
      <div className="circle" ref={circleRef}></div>
    </div>
  );
};

export default WelcomeToZeely;
